export const isBooleanTrue = <T>(x: T | null | undefined): x is T => !!x
